'use strict';
(function($){
	/*
	 * Vetology.Navigation widget
	 *
	 * @description This is the main Vetology Navigation widget that provides triggers for managing the page history and replacing url contents with ajax requests
	 *
	 * @options	See description for each option
	 *
	 * @method	See description above each method
	 */
	$.widget(
		'Vetology.Navigation',
		{
			"options": {
				"htmlHistory": [],
				"poping": false,
				"needs_pop": false,
				"instantiatedEs6Classes": []
			},
			/*
			 * Vetology.Navigation._init
			 *
			 * @description	Initializes the Vetology.Navigation
			 *
			 * @return NULL
			 *
			 */
			"_init": function(){
				var o = this;
				o._initEventHandlers();
				o._naviagateToID();
			},
			/*
			 * Vetology.Navigation._naviagateToID
			 *
			 * @description	Adds handlers to the platform url getters
			 *
			 * @return NULL
			 *
			 */
			"_naviagateToID": function(){
				var id = window.location.hash;
				if(id){
					$('[href="' + id + '"]').click();
				}
			},
			/*
			 * Vetology.Navigation._initEventHandlers
			 *
			 * @description	Adds handlers to the platform url getters
			 *
			 * @return NULL
			 *
			 */
			"_initEventHandlers": function(){
				var o = this;
				$('body').on('click', '.getUrl', function(e){
					e.preventDefault();
					o._getUrlContents($(this));
				});
				$('body').on('click', '.postUrl', function(e){
					e.preventDefault();
					$(".trash_on_post").remove();
					o._postUrlContents($(this));
				});
				$('body').on('click', '.closeLevel', function(e){
					e.preventDefault();
					var refresh = $('.platform_content.mainContent').find('.closeLevel').hasClass('doRefresh');
					o._processCloseEvent(this);
				});
				$("body").on("click", ".is_ajax", function(){
					o._getAjaxPage($(this));
				});
				window.onpopstate = function (event) {
					var refresh = $('.platform_content.mainContent').find('.closeLevel').hasClass('doRefresh');
					if (event.state !== null) {
						o._processCloseEvent(this, false);
					}
				};
			},
			/*
			 * Vetology.Navigation._getAjaxPage
			 *
			 * @description	REmoves the error highlightiung form the form block
			 *
			 * @return NULL
			 *
			 */
			"_getAjaxPage": function(el){
				var o = this;
				var level = {
					"html"			: $('.content-wrapper').html(),
					"scrollTo"		: $(window).scrollTop(),
					"filterValues"	: [],
					"isMain":		true
				};
				o.options.htmlHistory.push(level);
				$("body").Vetology("doRequest", "GET", {"is_ajax":1}, el.attr("href"),
					function(json){
						$(".content-wrapper").html(json.html);
						var cLocation = window.location.href;
						history.pushState({}, '', cLocation);
					}, "JSON",
					false, "Please wait while we get your " + el.html(), "We are almost done..."
				);
			},
			/*
			 * Vetology.Navigation._processCloseEvent
			 *
			 * @description	Process back action or close action by a button, mouse, or keyboard
			 *
			 * @return NULL
			 *
			 */
			"_processCloseEvent": function(elem, pop = false){
				var o = this;
				if(o.options.poping){
					o.options.poping = false;
					return false;
				}
				var config = o.options.htmlHistory.pop();
				if(typeof config === "undefined"){
					return;
				}
				let className = o.options.instantiatedEs6Classes.pop();
				while (typeof className !== 'undefined') {
					const event = new CustomEvent('vetology-unload-page-event', {
						detail: {
							className: className
						}
					});
					document.dispatchEvent(event);
					document.body.classList.remove('Vetology_class_' + className);
					className = o.options.instantiatedEs6Classes.pop();
				}
				if(config.isMain){
					$('.content-wrapper').html(config.html)
				} else {
					$('.platform_content.mainContent').html(config.html)
				}
				$("body").Filters("setFilters", config.filterValues);
				$(window).scrollTop(config.scrollTo);
				$(window).resize();
				$(window).scroll();
				$('.pop_content').popover();
				if(pop !== false){
					o.options.poping = true;
					history.back();
				}
				var text = $(elem).text();
				var dontPop = (text == 'Store' || text == 'Store only' || text == 'Submit for review');
				if(o.options.needs_pop && !dontPop){
					setTimeout(
						function(){
							o.options.needs_pop = false;
							$("body").Filters("getRecords");
						},
						300
					);
				}
				setTimeout(
					function() {
						try {
							if ($('.select2').data('select2')) {
								$('.select2-hidden-accessible').select2('destroy');
							}
						} catch (e) {
							console.log(e);
						}
						$(".select2.select2-container").remove();
						$('.select2').select2();
						$(".select2.select2-container").css('width', '100%');
					},
					400
				);
			},
			/*
			 * Vetology.Vetology._getUrlContents
			 *
			 * @description	Gets the contents of a given url
			 *
			 * @return NULL
			 *
			 */
			"_getUrlContents": function(el){
				var o = this;
				if(el.hasClass('preWarning')){
					if(el.data('cancel') == true){
						clearInterval(el.data('timer'));
						el.data('cancel', false);
						el.html(el.data('html'));
						return;
					}
					$("body").Vetology("vetologyShowDialog", "Case Delete:", el.data('warning'), "error", function(data, modal){
						modal.modal("hide");
						var i = 10;
						var preContent = el.html();
						var preDataContent = el.data('content');
						var successMessage = el.data('success-message');
						el.data('content', 'click here to cancel the action before the time runs out.');
						var theTimer = setInterval(
							function(){
								el.find('i').attr('class', 'vetology-session-timer');
								el.find('span').html('Cancel: ' + i);
								i --;
								if(i == -1){
									clearInterval(theTimer);
									el.html(preContent);
									$("body").Vetology("doRequest", "GET", {}, "/" + el.data("url"),
										function(json){
											if(json.success){
												$("body").Vetology("vetologyShowDialog", "Success:", successMessage, "success");
												var doneFunction = el.data('done-function');
												$("body").Vetology(
													"do",
													[
														doneFunction,
														el
													]
												);
											} else {
												$("body").Vetology("vetologyShowDialog", "We are sorry but:", json.errors, "error");
											}
										}, "JSON"
									);
								}
							},
							1000
						);
						el.data('timer', theTimer);
						el.data('cancel', true);
						el.data('html', preContent);
					}, "Cancel", "Continue");
				} else if(el.hasClass('postFunction')){
					var successMessage = el.data('success-message');
                    $("body").Vetology("doRequest",
						'GET',
						{},
						'/' + el.data('url'),
						function(json){
							if(json.success){
                                $('body').Vetology("vetologyShowDialog", 'Success:', successMessage, "success");
								var doneFunction = el.data('done-function');
                                $('body').Vetology(
									'do',
									[
										doneFunction,
										el
									]
								);
							} else {
                                $('body').Vetology("vetologyShowDialog", "Error:", json.errors, "error");
							}
						},
						'JSON'
					);
				} else if (el.hasClass('getUrlMessage')) {
					o.getUrlContentsGetMessage(el);
				} else {
					var filterValues = {};
					$('.isFilter').each(function(i, el){
						el = $(el);
						if(typeof el.data('filter') !== "undefined" && el.val().length > 0){
							filterValues[el.data('filter')] = el.val();
						}
					});
					var level = {
						"html"			: $('.platform_content.mainContent').html(),
						"scrollTo"		: $(window).scrollTop(),
						"filterValues"	: filterValues
					};
					o.options.htmlHistory.push(level);
                    el.popover('hide'); // explicitly close the popup...  it was lingering
					$("body").Vetology("doRequest", "GET", {}, "/" + el.data("url"),
						function (html) {
							o.getUrlContentsRequestCallback(html);
						}, "HTML"
					);
				}
			},

			getUrlContentsRequestCallback: function (html) {
				const o = this;
				const preClassListSize = document.body.classList.length;
				$(".platform_content.mainContent").html(html);
				const postClassListSize = document.body.classList.length;
				if(postClassListSize > preClassListSize) {
					for (let entry = preClassListSize; entry < postClassListSize; ++entry) {
						let classItem = document.body.classList.item(entry);
						if (classItem.indexOf('Vetology_class_') === 0) {
							const className = classItem.replace('Vetology_class_', '');
							// send out notice to this class instance
							console.info("Loading class " + className);
							const customEvent = new CustomEvent('vetology-load-page-event', {
								detail: {
									className: className
								}
							});
							document.dispatchEvent(customEvent);
							// save classname for when page is unloaded
							o.options.instantiatedEs6Classes.push(className);
						}
					}
				}
				$('.platform_content.mainContent').find('[data-value]').each(function () {
					$(this).val($(this).data('value'));
				});
				var cLocation = window.location.href;
				history.pushState({}, '', cLocation);
				$(window).scrollTop(0);
			},

			"getUrlContentsGetMessage": function (el) {
				const o = this;
				$("body").Vetology("doRequest", "GET", {}, "/" + el.data("url"),
					function (html) {
						let succeeded = true;
						if (typeof html === "object") {
							if (html.success) {
								if (html.message) {
									$("body").Vetology("vetologyShowDialog", 'Done:', html.message, "success");
								}
							} else if (html.message) {
								succeeded = false;
								$("body").Vetology("vetologyShowDialog", 'Done:', html.message, "error");
							}
						} else if (typeof html === 'string') {
							succeeded = o.getUrlContentsGetStringMessage(html, succeeded);
						}
						if (succeeded && el.hasClass('deleteRow')) {
							let row = el.get(0).closest('tr.row-actions');
							if (row) {
								row.previousElementSibling.remove();
								row.remove();
							} else {
								row = el.get(0).closest('tr');
								if (row) {
									row.remove();
								}
							}
							// update page count
							const counts = document.querySelectorAll('.box-title span.badge');
							counts.forEach(element => {
								const count = parseInt(element.textContent);
								element.textContent = '' + (count - 1);
							});
						}
					}, "HTML"
				);
		
			},

			getUrlContentsGetStringMessage: function (html, succeeded) {
				try {
					const obj = JSON.parse(html);
					if (typeof (obj) === 'object') {
						if (obj.success) {
							if (obj.message) {
								$("body").Vetology("vetologyShowDialog", 'Done:', obj.message, "success");
							}
						} else if (obj.message) {
							succeeded = false;
							$("body").Vetology("vetologyShowDialog", 'Done:', obj.message, "error");
						}

					} else if (typeof (obj) === 'string') {
						$("body").Vetology("vetologyShowDialog", 'Done:', obj, "success");
					}
				} catch (e) {
					$("body").Vetology("vetologyShowDialog", 'Done:', html, "success");
				}
				return succeeded;
			},

			/*
			 * Vetology.Vetology._postUrlContents
			 *
			 * @description	Psosts the contents of a given url
			 *
			 * @return NULL
			 *
			 */
			"_postUrlContents": function(item){
				var o = this;
				if(typeof CKEDITOR != "undefined"){
					var instance;
					for (instance in CKEDITOR.instances){
						CKEDITOR.instances[instance].updateElement();
					}
				}
				$.each($(".json_table"), function(i, el){
					el = $(el);
					el.JsonTables("updateRows");
				});
				$("body").Vetology("doRequest", "POST", item.closest('form').serialize(), item.data('url'),
					function (json) {
						o.postUrlContentsHandleReturn(json, item);
					}, "JSON"
				);
			},
			"postUrlContentsHandleReturn": function (json, item) {
				const o = this;
				var closeLevel = item.hasClass('saveAndCloseLevel');
				var closePage = item.hasClass('saveAndBackToPreviousPage');
				var doClean = item.hasClass('andClean');
				const returnUrl = item.get(0).dataset.return_url || false;
				var doneFunction = item.data('done-function');
				const errorFunction = item.data('error-function');
				var doneFunctionParams = item.data('done-function-params');
				var shred = item.data('shred');
				var successMessage = item.data('success-message');
				if (json.saved) {

					o.postUrlContentsHandleSaveReturn(doClean, item, json, returnUrl, closePage, successMessage, closeLevel, doneFunction, shred, doneFunctionParams);
				} else {
					if (typeof json.errors == "string") {
						$("body").Vetology("vetologyShowDialog", 'Error:', json.errors, "error");
					} else {
						var ul = "<ul>";
						$.each(json.errors, function (i, e) {
							$('body').find('[name="' + i + '"]').closest('.form-group').addClass('has-error').find(".help-block").html(e);
							ul += "<li>" + e + "</li>";
						});
						ul += "</ul>";
						$("body").Vetology("vetologyShowDialog", 'Error:', ul, "error");
					}
					if (typeof errorFunction !== 'undefined') {
						item.json = json;
						const el = item;

						$('body').Vetology(
							'do',
							[
								errorFunction,
								el,
								doneFunctionParams
							]
						);
					}
				}
				
			},

			postUrlContentsHandleSaveReturn: function (doClean, item, json, returnUrl, closePage, successMessage, closeLevel, doneFunction, shred, doneFunctionParams) {
				const o = this;
				var doClean = item.hasClass('andClean');
				item.json = json;
				o.options.needs_pop = true;
				if (returnUrl) {
					const customEvent = new CustomEvent('return-url-event', {
						detail: {
							originalEvent: item.get(0),
							returnUrl: returnUrl
						}
					});
					document.dispatchEvent(customEvent);
					// return;
				} else if (closePage) {
					var sucMessage = typeof json.alert != 'undefined' ? json.alert : (typeof successMessage != 'undefined' ? successMessage : 'The item has been successfully saved.');
					$("body").Vetology("vetologyShowDialog", 'Success:', sucMessage, "success");
					setTimeout(function () {
						window.location.replace(document.referrer);
					}, 800);
					// return;
				} else if (closeLevel) {
					o._processCloseEvent(item);
				} else if (doClean) {
					$('.platform_content.mainContent').find('input[type="text"]').val('');
					$('.platform_content.mainContent').find('input[type="password"]').val('');
					$('.platform_content.mainContent').find('input[type="email"]').val('');
					$('.platform_content.mainContent').find('input[type="checkbox"]').prop('checked', false);
					$('.platform_content.mainContent').find('select').val('');
				} else {
					if (json.update) {
						$.each(json.update, function (i, e) {
							$('[name="' + i + '"]').val(e);
							$('[name="' + i + '"]').html(e);
						});
					}
					if (json.disable) {
						$.each(json.disable, function (i, e) {
							$('[name="' + e + '"]').addClass('disabled').attr('disabled', 'disabled').val("");
						});
					}
					if (json.check) {
						$.each(json.disable, function (i, e) {
							$('[name="' + i + '"]').prop('checked', false);
							$('[name="' + i + '"][value="' + e + '"]').prop('checked', true);
						});
					}
					if (json.force_close) {
						o._processCloseEvent(item);
					}
				}
				var sucMessage = typeof json.alert != 'undefined' ? json.alert : (typeof successMessage != 'undefined' ? successMessage : 'The item has been successfully saved.');
				$("body").Vetology("vetologyShowDialog", 'Success:', sucMessage, "success");
				if (typeof doneFunction != 'undefined') {
					if (doneFunction == 'shred' || doneFunction == 'completeOCR') {
						var el = $(shred);
					} else {
						var el = item;
					}
					$('body').Vetology(
						'do',
						[
							doneFunction,
							el,
							doneFunctionParams
						]
					);
				}
				const customEvent = new CustomEvent('post-do-request-event', {
					detail: {
						originalEvent: item.get(0),
						json: json
					}
				});
				document.dispatchEvent(customEvent);
				return doClean;
			}


		}
	);
})(jQuery);


